module.exports = __webpack_public_path__ + "img/tarot-escudo-medio.9b038cea.svg";